import { ColDef, ValueSetterParams } from 'ag-grid-community';
import { NameCellComponent } from './cell-components/name-cell/name-cell.component';
import { DynamicCellComponent } from './cell-components/dynamic-cell/dynamic-cell.component';
import { NotificationReadCellComponent } from './cell-components/read-cell/read-cell.component';
import { notificationTypeTransformer } from './notification-helpers';

export const COL_DEF_NOTIFICATION_NAME: ColDef = {
  hide: false,
  headerName: 'Business',
  field: 'borrowerName',
  colId: 'borrowerName',
  filter: 'agTextColumnFilter',
  cellRenderer: NameCellComponent,
  cellStyle: (params) => { 
    const styles = {
      display: 'flex', 
      justifyContent: 'start',
      paddingLeft: 0,
    }

    if (params.node.rowIndex !== 0) {
      styles['margin-top'] = '12px';
    }

    return styles;
  },
  valueFormatter: ({ value, data }: { value: string, data }) => {
    const { borrowerName } = data;
    return `${borrowerName}`;
  },
  comparator: (valueA, valueB) => {
    const typeA: string = valueA?.trim();
    const typeB: string = valueB?.trim();
    return typeA?.localeCompare(typeB);
  }
};

export const COL_DEF_DYNAMIC_NOTIFICATION: ColDef = {
  flex: 1,
  hide: false,
  headerName: 'Actions',
  field: 'created',
  colId: 'created',
  cellRenderer: DynamicCellComponent,
  filter: 'agDateColumnFilter',
  valueSetter: (params: ValueSetterParams) => {
    return params.data.timestamp;
  },
  sortable: true,
  cellStyle: (params) => { 
    const styles = {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'start',
      'align-items': 'end',
      paddingLeft: 0
    }

    if (params.node.rowIndex !== 0) {
      styles['margin-top'] = '8px';
    }

    return styles;
  },
};

export const COL_DEF_READ_STATE: ColDef = {
  minWidth: 24,
  maxWidth: 30,
  hide: false,
  headerName: 'Read',
  field: 'read',
  colId: 'read',
  filter: 'agDateColumnFilter',
  valueSetter: (params: ValueSetterParams) => {
    return params.data.read;
  },
  cellRenderer: NotificationReadCellComponent,
  cellStyle: (params) => { 
    const styles = {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'start',
      alignItems: 'center',
      padding: 0,
      'margin-top': '2px'
    }

    if (params.node.rowIndex !== 0) {
      styles['margin-top'] = '15px';
    }

    return styles;
  },
}
// Necessary for quick filter inclusion
export const COL_DEF_ACTIVITY: ColDef = {
  hide: true,
  headerName: 'Activity',
  getQuickFilterText: params => {
    return notificationTypeTransformer(params.data.activityType);
  },
  field: 'activityType',
  colId: 'activityType'
}
